import '../index.css'
import * as React from 'react'
import { useContext } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { PlusOutlined } from '@ant-design/icons'
import { InfoCxt } from '../../../App'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

interface LabResultDataType {
  id: string
  testName: string
  result: string
  referenceRange: string
  date: string
}

const columns: ColumnsType<LabResultDataType> = [
  { title: 'Test Name', dataIndex: 'testName' },
  { title: 'Result', dataIndex: 'result' },
  { title: 'Reference Range', dataIndex: 'referenceRange' },
  { title: 'Date', dataIndex: 'date' },
  { title: 'Action', width: '116px', render: () => null },
]

/* -------------------------------- react fc -------------------------------- */

const LabResults: React.FC = () => {
  const { showComingSoon } = useContext(InfoCxt)

  return (
    <>
      <TabHeader border>
        <PageTitle text='Lab Results' />
        <Button type='primary' ghost icon={<PlusOutlined />} onClick={showComingSoon}>
          Add
        </Button>
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Lab Results' />
        <TableBox>
          <Table columns={columns} dataSource={[]} rowKey={(record) => record.id} pagination={false} />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export default LabResults
